import React, { useContext, useEffect } from "react";
import { APIContext } from "src/components/Contexts/APIContext"
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Tabs, { tabsClasses } from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import ScorecardTimer from "./ScorecardTimer";
import { CallInfoTabsHaveValues } from "./ViewModels/CallInfoTabsHaveValues";

const tabBorderStyle = 'solid 1px black';

const styles = {
    tab: {
        color: '#fff',
        backgroundColor: '#1d8abf',
        borderBottom: tabBorderStyle,
        borderRadius: 0,
        borderTop: '1px white solid',
        '&:hover': {
            backgroundColor: '#1d8abf'
        }
    },
    endTab: {
        color: '#fff',
        backgroundColor: '#1d8abf',
        borderBottom: tabBorderStyle,
        borderRadius: 0,
        borderTop: '1px white solid',
        borderRight: '1px black solid',
        '&:hover': {
            backgroundColor: '#1d8abf'
        }
    },
    selectedTab: {
        backgroundColor: '#fff',
        color: '#1d8abf',
        borderTop: tabBorderStyle,
        borderLeft: tabBorderStyle,
        borderRight: tabBorderStyle + " !important",
        borderRadius: 0,
        '&:hover': {
            backgroundColor: '#fff'
        }
    },

}

interface ISecondaryCallTabsProps {
    index: number;
    setIndex: (index: number) => void;
    feedbackView?: string;
    agentView?: boolean;
    mainView?: boolean;
    timerActive: boolean;
    roleCanSeeScorecard: boolean;
    callInfoTabsEnabled: CallInfoTabsHaveValues | null;
}

export default function SecondaryCallTabs(props: ISecondaryCallTabsProps) {
    const { isClient, isClientAIEnabled, isClientTranscriptsEnabled } = useContext(APIContext);
    const transcriptsEnabled = !isClient || isClientTranscriptsEnabled;
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

    //make sure tabs are in the same order as the array in CallTabPages
    const tabs = [
        ...props.feedbackView ? [{ label: "Feedback", isAI: false, enabled: true }] : [],
        { label: "Voice of the Customer Summary", isAI: true, enabled: props.callInfoTabsEnabled ? props.callInfoTabsEnabled.vocSummaryHasValues : false },
        { label: "Voice of the Customer Details", isAI: true, enabled: props.callInfoTabsEnabled ? props.callInfoTabsEnabled.vocDetailsHasValues : false },
        { label: "Insights", isAI: true, enabled: props.callInfoTabsEnabled ? props.callInfoTabsEnabled.insightsHasValues : false },
        { label: "Sales-AI", isAI: true, enabled: props.callInfoTabsEnabled ? props.callInfoTabsEnabled.salesAIHasValues : false },
        { label: "CX-AI", isAI: true, enabled: props.callInfoTabsEnabled ? props.callInfoTabsEnabled.guideHasValues : false },
        { label: "Call Details", isAI: false, enabled: true },
        ... !props.agentView && props.roleCanSeeScorecard ? props.mainView ? [{ label: "Scorecard", isAI: true, enabled: true }] : transcriptsEnabled ? [{ label: "Transcript", isAI: true, enabled: true }] : [] : [],
    ];

    if (isClient && !isClientAIEnabled) {
        props.setIndex(
            tabs.findIndex(tab => tabs
                .filter(tab => !tab.isAI)[0].label === tab.label)
        );
    }

    useEffect(() => {
        // If the vocSummary tab is disabled and the vocDetails tab is enabled, switch to the vocDetails tab, otherwise switch to "Call Details"
        if (props.callInfoTabsEnabled && props.callInfoTabsEnabled.vocSummaryHasValues == false) {
            if (props.callInfoTabsEnabled.vocDetailsHasValues == true)
                props.setIndex(tabs.findIndex(t => t.label === "Voice of the Customer Details"));
            else
                props.setIndex(tabs.findIndex(t => t.label === "Call Details"));
        }
    }, [props.callInfoTabsEnabled]);

    return (
        <>
            {isSmallScreen ?
                <Tabs variant="scrollable"
                    scrollButtons
                    value={false}
                    sx={{
                        [`& .${tabsClasses.scrollButtons}`]: {
                            '&.Mui-disabled': { opacity: 0.3 },
                        },
                    }}>
                    {tabs.map((tab, i) =>
                        <Tab
                            key={i}
                            value={i}
                            onClick={() => props.setIndex(i)}
                            disabled={(tab.isAI && isClient && !isClientAIEnabled) || !tab.enabled}
                            label={tab.label}
                            sx={props.index === i ? styles.selectedTab : i === tabs.length - 1 ? styles.endTab : styles.tab}
                            style={i !== tabs.length - 1 && i !== props.index - 1 ? { borderRight: '1px white solid' } : {}}
                        />)
                    }
                </Tabs>
                :
                <Stack direction="row">
                    {tabs.map((tab, i) =>
                        <Button
                            key={i}
                            onClick={() => props.setIndex(i)}
                            fullWidth
                            disabled={(tab.isAI && isClient && !isClientAIEnabled) || !tab.enabled}
                            sx={props.index === i ? styles.selectedTab : i === tabs.length - 1 ? styles.endTab : styles.tab}
                            style={i !== tabs.length - 1 && i !== props.index - 1 ? { borderRight: '1px white solid' } : {}}
                        >
                            {(tab.label === "Scorecard" && props.timerActive) ?
                                < ScorecardTimer />
                                :
                                <>
                                    {tab.label}
                                </>
                            }
                        </Button>)
                    }
                </Stack >
            }
        </>
    )
}